module.exports = __webpack_public_path__ + "img/PSS.ce652268.jpg";